<template>
  <vs-sidebar ref="navTaskSidebar" click-not-close position-right parent="body" default-index="1" color="primary" class="vs-con-loading__container add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar ref="sidebarScrollArea" class="vs-con-loading__container scroll-area--data-list-add-new pt-4 pb-6" :settings="settings" id="navigationTaskDetails">

      <div class="pl-6 pr-6 pb-6">
        <div v-if="this.$siteTypeId() != 1">
          <div>
            <label>Task Classification</label>
            <v-select class="mb-3" ref="taskClassificationTypeDropdown" placeholder="Search / Select Task Classification"  :options="taskClassificationTypeList" v-model="taskClassificationTypeText"></v-select>
          </div>
        </div>
        <div>
          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" class="w-full mb-3" v-model="formData.name"/>
          <label>Navigation Map</label>
          <v-select class="w-full style-chooser" placeholder="Search / Select Navigation Map" :options="navigationMaps" v-model="navigationMapDropdown" @search:focus="clearLocations" @search:blur="getMappedLocations" @input="showLocations = true"></v-select>
        </div>

        <div class="mt-3" style="display: inline-grid;">
          <label>Task Number</label>
          <vs-input-number class="numberinput" onClick="this.select();" v-model="formData.number" min="0" />
        </div>
        <div v-if="this.$siteTypeId() != 1">
          <vs-divider>Outcomes</vs-divider>

            <div>
              <label>Assessment Criteria</label>
              <v-select class="mb-2" ref="assessmentCriteriaDropdown" placeholder="Search / Select Assessment Criteria"  :options="assessmentCriteriaList" v-model="assessmentCriteriaText"></v-select>
            </div>
            <div>
              <label>Essential Embedded Knowledge</label>
              <v-select class="mb-2" ref="eEKDropdown" placeholder="Search / Select EEK"  :options="eekList" v-model="essentialEmbeddedKnowledgeText"></v-select>
            </div>
            <div>
              <label>Unit Standard</label>
              <v-select class="mb-2" ref="unitStandardDropdown" placeholder="Search / Select Unit Standard"  :options="unitStandardList" v-model="unitStandardText"></v-select>
            </div>
              <div>
                <label>Spesific Outcome</label>
                <v-select class="mb-2" ref="spesificOutcomeDropdown" placeholder="Search / Select Spesific Outcome"  :options="spesificOutcomeList" v-model="spesificOutcomeText"></v-select>
              </div>
        </div>
        <div class="pt-4" v-show="showLocations">
          <vs-divider class="my-0">Options</vs-divider>
          <div>
            <ul>
              <li v-for="(option, index) in formData.locationOptions" :key="index">
                <div class="vx-row mx-0">
                  <vs-divider position="left" class="pt-2 float-center"><strong>{{option.name == null ? option.navigationMapLocation.name : option.name}}</strong></vs-divider>
                </div>
                <div class="vx-row mx-0">
                  <label class="pt-2 float-left">Module</label>
                  <v-select class="w-full style-chooser" :ref="'moduleDropdown' + option.id" :value="option.modules.filter(function (item) {return item.value == option.moduleId;})[0].text"  :options="option.modules.map((item) => {return {label: item.text, value: item.value} })" @search:blur="getModuleGotos('moduleDropdown' + option.id, option.id)"></v-select>

                  <label class="pt-2 float-left">Go To</label>
                  <vs-select placeholder="Go To" class="w-full pb-3" vs-multiple autocomplete v-model="option.nextTaskId">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in option.tasks" />
                  </vs-select>
                  <div class="w-full">
                    <div style="margin-bottom: 8px; margin-top: 2px;">
                      <vs-checkbox color="success" v-model="option.useCoins">Coins</vs-checkbox>
                    </div>
                    <div v-if="option.useCoins && showLocations">
                      <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                        <vs-switch color="success" v-model="option.isCoinsRecurring">
                          <span slot="on">Recurring</span>
                          <span slot="off">Once Only</span>
                        </vs-switch>
                        <vs-switch style="margin-left: 10px;" color="success" v-model="option.addCoins">
                          <span slot="on">Add</span>
                          <span slot="off">Deduct</span>
                        </vs-switch>
                      </div>
                      <label style="margin-left: 5px;">Coin Value</label>
                      <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="option.coinValue" />
                      <span class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addEditNavigation" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" @click="deleteApproach" v-show="formData.id" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { setTimeout } from 'timers';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    courseId: {
      type: String,
      required: true
    },
    moduleId: {
      type: String,
      required: true
    },
    nodeSelected: {
      type: Object,
      required: false
    },
    taskClassificationTypes: {
      type: Array,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
    sourceTaskId: {
      type: Number,
      required: false
    },
    taskTypeList: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        name: "",
        moduleId: "",
        navigationMapId: "",
        locationOptions: [],
        sourceTaskId: 0,
        taskTypeId: 0,
        hasLogs: false,
        number: 0,
        spesificOutcomeId: null,
        unitStandardId: null,
        assessmentCriteriaId: null,
        essentialEmbeddedKnowledgeId: null,
        taskClassificationTypeId: null,
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      modules: [],
      navigationMaps: [],
      counterDanger: false,
      showLocations: false,
      navigationMapDropdown: 0,
      listModuleDropdown: [],
      spesificOutcomeDropdown: null,
      unitStandardDropdown: null,
      assessmentCriteriaDropdown: null,
      eEKDropdown: null,
      taskClassificationTypeDropdown: null,
      spesificOutcomeList: [],
      unitStandardList: [],
      assessmentCriteriaList: [],
      eekList: [],
      taskClassificationTypeList: [],
      spesificOutcomeText: null,
      unitStandardText: null,
      assessmentCriteriaText: null,
      essentialEmbeddedKnowledgeText: null,
      taskClassificationTypeText: null,
    };
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  computed: {
    isDisabled: function() {
      return !(this.navigationMapDropdown.value && this.formData.name);
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        var self = this;

        var onModuleSuccess = response => { self.modules = response.data; };
        var onNavMapSuccess = response => { self.navigationMaps = response.data.map((item) => {return {label: item.text, value: item.value} }); };

        self.$ajaxGet(self, "Module/GetSelectList", onModuleSuccess);
        self.$ajaxGet(self, "NavigationMap/GetSelectList", onNavMapSuccess);

        self.taskClassificationTypeList = self.taskClassificationTypes;

        self.getEEK();
        self.getUnitStandard();
        self.getSpesificOutcome();
        self.GetAssessmentCriteria();
        
        if(self.nodeSelected.id){
          self.formData.id = self.nodeSelected.id;
          self.formData.name = self.nodeSelected.name;
          self.taskClassificationTypeText = self.taskClassificationTypeList.filter(function(item){return item.value == self.nodeSelected.taskClassificationTypeId})[0];

          if (self.nodeSelected.number)
            self.formData.number = self.nodeSelected.number;
          else
            self.formData.number = 0;

          self.formData.sourceTaskId = self.sourceTaskId;
          self.formData.moduleId = self.moduleId;
          self.navigationMapDropdown = self.navigationMaps.filter(function(item){return item.value == self.nodeSelected.navigationTask.navigationMapId;})[0];
          if(self.nodeSelected.navigationTask.locationOptions.length != 0)
            self.formData.locationOptions = self.nodeSelected.navigationTask.locationOptions;
          else{
            self.formData.moduleId = self.moduleId;
            self.getMappedLocations();
          }
          self.formData.hasLogs = self.nodeSelected.navigationTask.hasLogs;
          self.showLocations = true;

        }else{
          this.initValues(self.sourceTaskId || 0);
        }
      }else {
        var scrollOptions = {
          container: '#navigationTaskDetails',
          easing: 'ease-in',
          offset: -10000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 0, scrollOptions);
      }
    },
  },
  methods: {
    getEEK(){
      var self =this;

      var onSuccess = function (response) {
        self.eekList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.essentialEmbeddedKnowledgeText = self.eekList.filter(function(item){return item.value == self.nodeSelected.essentialEmbeddedKnowledgeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/EEK?courseId=" + self.courseId, onSuccess);
    },
    getUnitStandard(){
      var self =this;

      var onSuccess = function (response) {
        self.unitStandardList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.unitStandardText = self.unitStandardList.filter(function(item){return item.value == self.nodeSelected.unitStandardId})[0];
        }
      }

      self.$ajaxGet(self, "Course/UnitStandard?courseId=" + self.courseId, onSuccess);
    },
    getSpesificOutcome(){
      var self =this;

      var onSuccess = function (response) {
        self.spesificOutcomeList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.spesificOutcomeText = self.spesificOutcomeList.filter(function(item){return item.value == self.nodeSelected.spesificOutcomeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/SpecificOutcome?courseId=" + self.courseId, onSuccess);
    },
    GetAssessmentCriteria(){
      var self =this;

      var onSuccess = function (response) {
        self.assessmentCriteriaList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.assessmentCriteriaText = self.assessmentCriteriaList.filter(function(item){return item.value == self.nodeSelected.assessmentCriteriaId})[0];
        }
      }

      self.$ajaxGet(self, "Course/AssesmentCriteria?courseId=" + self.courseId, onSuccess);
    },
    initValues(val) {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.number = 0;
      this.formData.sourceTaskId = 0;
      this.spesificOutcomeText= null;
      this.unitStandardText = null;
      this.assessmentCriteriaText = null;
      this.essentialEmbeddedKnowledgeText = null;
      this.taskClassificationTypeText = null;
      if(val){
        this.formData.sourceTaskId = val;
      }
      
      this.formData.navigationMapId = "";
      this.formData.locationOptions = [];
      this.formData.taskTypeId = "";
      this.formData.moduleId = this.moduleId;
      this.showLocations = false;
      this.navigationMapDropdown = 0;
      this.errors.clear();
    },
    getModuleGotos(dropdownRef, id) {
      const self = this;

      var changedModuleId = self.$refs[dropdownRef][0].valueAsArray[0].value;
      if(changedModuleId) {
        var locationToUpdate = self.formData.locationOptions.filter(function(item){
          return item.id == id
        })[0];

        var onSuccess = function (response) {
          locationToUpdate.tasks = response.data.tasks.map(function(item) {
            if (item.name == null || item.name == "")
              return { value: item.id, text: item.displayId }
            else
              return { value: item.id, text: item.displayId + " : " + item.name }
          });
        };

        self.$ajaxGet(self, "course/getstory/" + changedModuleId, onSuccess);
      }
    },
    clearLocations() {
      var self = this;
      self.formData.navigationMapId = "";
      self.navigationMapDropdown = 0;
      self.formData.locationOptions = [];
      self.showLocations = false;
    },
    getMappedLocations() {
      const self = this;

      var onSuccess = function(response) {
        self.formData.locationOptions = response.data;
        self.showLocations = true;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
      };

      if(self.navigationMapDropdown.value){
        self.showLoadingOnSidebar();
        self.$ajaxGet(self, "NavigationMap/ListTaskMapLocations" + "?navigationMapId=" + self.navigationMapDropdown.value + "&moduleId=" + self.formData.moduleId, onSuccess, onFinally);
      }
    },
    loadData() {
      var self = this;
      var onNavMapSuccess = function(response) {
        self.navigationMaps = response.data.map((item) => {return {label: item.text, value: item.value} });
      };
      self.$ajaxGet(self, "NavigationMap/GetSelectList", onNavMapSuccess);
    },
    saveData(val,taskTypeId){
      this.$emit('saveData',val,taskTypeId);
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
      this.initValues(val);
    },
    addEditNavigation() {
      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();
          self.formData.moduleId = self.moduleId;
          self.formData.navigationMapId = parseInt(self.navigationMapDropdown.value);

          var onSuccess = response => {
            self.saveData(0, self.formData.taskTypeId);
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Task Saved",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          };

          var onFinally = function () {
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
          };
          
          self.formData.taskClassificationTypeId = self.taskClassificationTypeText ? self.taskClassificationTypeText.value: null;

          self.formData.unitStandardId = self.unitStandardText ? self.unitStandardText.value: null

          self.formData.essentialEmbeddedKnowledgeId = self.essentialEmbeddedKnowledgeText ? self.essentialEmbeddedKnowledgeText.value: null;

          self.formData.assessmentCriteriaId = self.assessmentCriteriaText ?  self.assessmentCriteriaText.value: null;

          self.formData.spesificOutcomeId = self.spesificOutcomeText ?  self.spesificOutcomeText.value: null;

          self.$ajaxPost(self, "navigationtask/addeditnavigationtask", self.formData, onSuccess, onFinally);
        }
      });
      var scrollOptions = {
        container: '#navigationTaskDetails',
        easing: 'ease-in',
        offset: -1000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 500, scrollOptions);
    },
    deleteTask() {
      var self = this;
      self.showLoadingOnDeleteButton();
      if(self.formData.hasLogs)
        self.showLoadingOnCytoscape();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Task Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
        self.$vs.loading.close(self.$parent.$el);
      };

      self.$ajaxDelete(self, "navigationtask/deletenavigationtask/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnSidebar(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.sidebarScrollArea.$el,
        scale: 1
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnCytoscape(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    deleteApproach() {
      if(this.formData.hasLogs)
        this.openConfirm();
      else
        this.deleteTask();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected navigation task?',
        accept: this.deleteTask,
        acceptText: "Yes, delete",
        cancelText: "No, cancel"
      })
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background {
      z-index: 52010;
    }
    /deep/ .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
      .img-upload {
        margin-top: 2rem;
        .con-img-upload {
          padding: 0;
        }
        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
